import $ from "jquery"
import Handlebars from "handlebars"
import { PersonModel } from "../model"
import htmlMainTemplate from "./mainTemplate.html"
import htmlItemTemplate from "./itemTemplate.html"

export type ComponentReadyCallback = (node:JQuery) => void

export type StateChangedCallback = (model:PersonModel, state: PersonState) => void

export type Properties = {
    componentReady:ComponentReadyCallback
    data: PersonModel[]
}

export type PersonState = {
    muted:boolean
    meMode:boolean
}

export type StateProperty = "none" | keyof PersonState

export class People {

    private mainNode:JQuery

    constructor(properties:Properties) {
        this.mainNode = $(htmlMainTemplate)

        const itemTemplate = Handlebars.compile(htmlItemTemplate)
        for(let key in properties.data) {
            const model = properties.data[key]
            const node = $(itemTemplate(model)).data("model", model).on("change", this.handleOnChange.bind(this))
        
            this.mainNode.append(node)
        }

        properties.componentReady(this.mainNode)
    }

    public onMuteStateChanged(callback:StateChangedCallback) {
        this.mainNode.on("personStateChanged", (e:JQuery.EventBase, property:StateProperty, value:unknown, model:PersonModel, state:PersonState) => {
            if(property == "muted") {
                callback(model, state)
            }
        })
    }

    public onMeModeStateChanged(callback:StateChangedCallback) {
        this.mainNode.on("personStateChanged", (e:JQuery.EventBase, property:StateProperty, value:unknown, model:PersonModel, state:PersonState) => {
            if(property == "meMode") {
                callback(model, state)
            }
        })
    }

    private handleOnChange(e:JQuery.ChangeEvent) {
        const eventSource = $(e.target)
        const itemNode = $(e.currentTarget)
        const model = itemNode.data("model")
        let property:StateProperty = "none"
        let newValue:any = null
        let meModeValue = itemNode.find(".input-me-mode").is(":checked")
        let muteValue = itemNode.find(".input-mute").is(":checked")

        if(eventSource.hasClass("input-me-mode")) {
            property = "meMode"
            newValue = meModeValue
            this.mainNode.find("input.input-me-mode").not(eventSource).prop("checked", false)
        } else if(eventSource.hasClass("input-mute")) {
            property = "muted"
            newValue = muteValue
        }

        this.mainNode.trigger("personStateChanged", [property, newValue, model, {
            meMode: meModeValue,
            muted: muteValue
        }])
    }
}